//Componentes generales
import React, { useReducer } from "react";
import proveedoresReducer from "./proveedoresReducer";
import proveedoresContext from "./proveedoresContext";

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import { getProviders, uploadProvider } from "../../api/abmProvider"

//Acciones
import { 
    ACTUALIZAR_PROVEEDORES,
    ACTUALIZAR_PROVEEDORES_DB,
    CARGANDO_PROV,
    ERROR_PROV,
    LIMPIAR_ERROR
} from "./proveedoresActions";

/* 
    State encargado de la gestión de proveedores.
*/
const ProveedoresState = props => {

    //Valores iniciales
    const initialState = {
        proveedores: [],
        cargando: false,
        error: ""
    };

    const [state, dispatch] = useReducer(proveedoresReducer, initialState);

    /* 
        Función recuperar los proveedores y a su vez actualizarlos.
    */
    const actualizarProveedores = async () => {

        try{
            console.log("ENTRO AL ACTUALIZAR PROVEEDORES");
            const resp = await getProviders();
            dispatch({
                type: ACTUALIZAR_PROVEEDORES,
                payload: resp.data.data
            })
            console.log("RESPUESTA DE PROVEEDORES SQL",resp)
            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

    /* 
        Función encargada de sobreescribir la tabla de proveedores con la propia de Softland.
            Donde userID es el ID del usuario en sesión.
                  userName es el nombre del usuario en sesión.
    */
    const actualizarProveedoresDB = async (userID, userName) => {

        try{
            console.log("ENTRO AL ACTUALIZAR PROVEEDORES DB");
            await uploadProvider(userID, userName);
            const resp = await getProviders();
            dispatch({
                type: ACTUALIZAR_PROVEEDORES_DB,
                payload: resp.data.data
            });
            console.log("RESPUESTA DE PROVEEDORES MONGO",resp)
        return {status: true, msg: "Se actualizo con exito la base de datos."};

        }catch(error){
            console.log(error);
            dispatch({
                type: ERROR_PROV,
                payload: error.response.data.errMsg
            });

            return {status: false, msg: error.response.data.errMsg};
        }
    }

    const cargando =  () => {
        dispatch({
            type: CARGANDO_PROV
        })
    }

    const limpiarError = () => {
        dispatch({
            type: LIMPIAR_ERROR
        })
    }

    return(
        <proveedoresContext.Provider
            value={{
                proveedores: state.proveedores,
                isCargando: state.cargando,
                error: state.error,
                actualizarProveedores,
                actualizarProveedoresDB,
                cargando,
                limpiarError
            }}
        >

            {props.children}

        </proveedoresContext.Provider>
    )
    
}

export default ProveedoresState;